import { render, staticRenderFns } from "./vue-list.vue?vue&type=template&id=7cdd2af8&"
import script from "./vue-list.vue?vue&type=script&lang=js&"
export * from "./vue-list.vue?vue&type=script&lang=js&"
import style0 from "./vue-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports